module.exports = __webpack_public_path__ + "img/Group 77@2x.6b05a9a6.png";